let api_url = "http://localhost:8000/api/";
let remote_url = "http://localhost:7000/api/occp16/ws/";
let socket_url = "ws://localhost:7000/status";
let url = "https://api.mobilitymeasure.app/";
let url1 = "https://mobilitymeasure.app";


if (process.env.NODE_ENV === "development") {
  api_url = "http://127.0.0.1:8003/api/";
  url = "http://127.0.0.1:8003/";
}

if (process.env.NODE_ENV === "production") {
  api_url = "https://api.mobilitymeasure.app/api/";
  //remote_url = "https://socket.evaa.app/api/occp16/ws/";
  //socket_url = "wss://socket.evaa.app/status";
}

export const BACKENDURL = url;
export const FRONTENDURL = url1;
export const BASE_URL = api_url;
export const REMOTE_URL = remote_url;
export const SOCKET_URL = socket_url;
export const STORAGE_URL = "https://api.mobilitymeasure.app/storage/"